import type { AxiosResponse } from 'axios';
import Api from '@/data/Api.ts';

const URL_CHANGELOG_VERSION = 'changelog-version';
const URL_CHANGELOG = 'changelog';

export default class ChangelogApi extends Api {
  getVersion(): Promise<AxiosResponse<{ version: string }>> {
    return this.standardGet(URL_CHANGELOG_VERSION, {});
  }

  get(includePending: boolean = false): Promise<any> {
    return this.standardGet(
      URL_CHANGELOG,
      { include_pending: includePending },
      [],
    );
  }
}
